var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8125 38.0625V7.25C32.8125 6.14543 31.9171 5.25 30.8125 5.25H11.1875C10.0829 5.25 9.1875 6.14543 9.1875 7.25V38.0625H2.625C1.90013 38.0625 1.3125 38.6501 1.3125 39.375V39.375C1.3125 40.0999 1.90013 40.6875 2.625 40.6875H39.375C40.0999 40.6875 40.6875 40.0999 40.6875 39.375V39.375C40.6875 38.6501 40.0999 38.0625 39.375 38.0625H32.8125ZM30.1875 38.0625H11.8125V7.875H30.1875V38.0625Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 23H28V27H26V23Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15.5L17.5 14.5L25.5 14.5L25.5 15.5L17.5 15.5Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/door.c1f73709a92cf33df02326e78523dc22.svg";
export { ForwardRef as ReactComponent };